<po-page-list
  p-title="Manutenção de DDA"
  [p-breadcrumb]="breadcrumb"
  [p-filter]="filterSettings"
>

  <po-table class="po-sm-12 po-md-12 po-lg-12"
    [p-height]="tabelaPrincipalHeight"
    [p-striped]="true"
    [p-columns]="tabelaPrincipalColunas"
    [p-items]="tabelaPrincipalItens"
    [p-show-more-disabled]="tabelaPrincipalShowMoreDisable"
    (p-show-more)="tabelaPrincipalLoad(false)"
    p-actions-right="false"
    [p-actions]="tabelaPrincipalActions"
    p-spacing="small"
    [p-filter-type]="poSearchFilterMode"
    p-hide-table-search="false"
  ></po-table>
</po-page-list>

<po-modal #advancedFilterModal p-title="Filtros" [p-primary-action]="advancedFilterPrimaryAction">
  <form #f="ngForm">
    <po-input class="po-sm-12 po-md-4 po-lg-4"
      name="CFIGTITULO"
      p-label="Cod.Titulo DDA"
      [(ngModel)]="tabelaPrincipalFiltro.dados.CFIGTITULO"
      p-clean="true"
    ></po-input>
    <po-lookup class="po-sm-12 po-md-8 po-lg-8"
      p-label="Fornecedor"
      name="CFIGFORNECELOJA"
      [(ngModel)]="tabelaPrincipalFiltro.dados.CFIGFORNECELOJA"
      p-field-label="CA2NREDUZ"
      p-field-value="CA2CODLOJA"
      [p-columns]="fornecedorColumnsFilters"
      [p-field-format]="fornecedorLookupService.getFieldFormater"
      [p-filter-service]="fornecedorLookupService"
      [p-advanced-filters]="fornecedorLookupService.getAdvancedFilter()"
      [p-literals]="{ modalTitle: 'Fornecedor' }"
    ></po-lookup>
    <po-datepicker class="po-sm-12 po-md-4 po-lg-4"
      name="DFIGDATA_DE"
      p-label="Emissão de:"
      [(ngModel)]="tabelaPrincipalFiltro.dados.DFIGDATA_DE"
      [p-iso-format]="formatExtended"
      p-format="dd/mm/yyyy"
    ></po-datepicker>
    <po-datepicker class="po-sm-12 po-md-4 po-lg-4"
      name="DFIGDATA_ATE"
      p-label="Emissão até:"
      [(ngModel)]="tabelaPrincipalFiltro.dados.DFIGDATA_ATE"
      [p-iso-format]="formatExtended"
      p-format="dd/mm/yyyy"
    ></po-datepicker>
    <po-datepicker class="po-sm-12 po-md-4 po-lg-4"
      name="DFIGVENCTO_DE"
      p-label="Vencimento de:"
      [(ngModel)]="tabelaPrincipalFiltro.dados.DFIGVENCTO_DE"
      [p-iso-format]="formatExtended"
      p-format="dd/mm/yyyy"
    ></po-datepicker>
    <po-datepicker class="po-sm-12 po-md-4 po-lg-4"
      name="DFIGVENCTO_ATE"
      p-label="Vencimento até:"
      [(ngModel)]="tabelaPrincipalFiltro.dados.DFIGVENCTO_ATE"
      [p-iso-format]="formatExtended"
      p-format="dd/mm/yyyy"
    ></po-datepicker>
    <po-datepicker class="po-sm-12 po-md-4 po-lg-4"
      name="DFIGDTCONC_DE"
      p-label="Conciliação de:"
      [(ngModel)]="tabelaPrincipalFiltro.dados.DFIGDTCONC_DE"
      [p-iso-format]="formatExtended"
      p-format="dd/mm/yyyy"
    ></po-datepicker>
    <po-datepicker class="po-sm-12 po-md-4 po-lg-4"
      name="DFIGDTCONC_ATE"
      p-label="Conciliação até:"
      [(ngModel)]="tabelaPrincipalFiltro.dados.DFIGDTCONC_ATE"
      [p-iso-format]="formatExtended"
      p-format="dd/mm/yyyy"
    ></po-datepicker>
    <po-select class="po-sm-12 po-md-4 po-lg-4"
      name="CFIGCONCIL"
      p-label="Conciliado"
      [(ngModel)]="tabelaPrincipalFiltro.dados.CFIGCONCIL"
      [p-options]="tabelaPrincipalFiltro.listaConciliado">
    </po-select>
    <po-select class="po-sm-12 po-md-4 po-lg-4"
      name="pageSize"
      p-label="Paginação"
      [(ngModel)]="tabelaPrincipalFiltro.dados.pageSize"
      [p-options]="tabelaPrincipalFiltro.listaPaginacao"
      [p-required]="true"
    ></po-select>
  </form>
</po-modal>


<po-modal
  #DDAModal
  p-title="DDA"
  p-size="lg"
>
  <form #DDAForm="ngForm">
    <po-datepicker class="po-sm-12 po-md-3 po-lg-2"
      name="DFIGDATA"
      p-label="Dt.Processamento Arquivo"
      [(ngModel)]="DDA.DFIGDATA"
      [p-iso-format]="formatExtended"
      p-format="dd/mm/yyyy"
      p-required="true"
      p-show-required="true"
    ></po-datepicker>
    <po-lookup class="po-sm-12 po-md-8 po-lg-4"
      p-label="Fornecedor"
      name="fornecedorCodigoLoja"
      [(ngModel)]="fornecedorCodigoLoja"
      p-field-label="CA2NREDUZ"
      p-field-value="CA2CODLOJA"
      [p-columns]="fornecedorColumnsFilters"
      [p-field-format]="fornecedorLookupService.getFieldFormater"
      [p-filter-service]="fornecedorLookupService"
      [p-advanced-filters]="fornecedorLookupService.getAdvancedFilter()"
      [p-literals]="{ modalTitle: 'Fornecedor' }"
      (p-selected)="fornecedorSelecionado($event)"
      p-required="true"
      p-show-required="true"
    ></po-lookup>
    <po-input class="po-sm-6 po-md-3 po-lg-2"
      name="CFIGCNPJ"
      p-label="CNPJ/CPF do Fornecedor"
      [(ngModel)]="DDA.CFIGCNPJ"
      p-required="true"
      p-show-required="true"
      p-maxlength="14"
      p-disabled="true"
    ></po-input>
    <po-input class="po-sm-6 po-md-3 po-lg-2"
      name="CFIGTITULO"
      p-label="Cod.Título DDA"
      [(ngModel)]="DDA.CFIGTITULO"
      p-required="true"
      p-show-required="true"
      p-maxlength="15"
      p-disabled="false"
    ></po-input>
    <po-input class="po-sm-6 po-md-3 po-lg-2"
      name="CFIGTIPO"
      p-label="Espécie Título DDA"
      [(ngModel)]="DDA.CFIGTIPO"
      p-required="true"
      p-show-required="true"
      p-maxlength="3"
      p-disabled="false"
    ></po-input>
    <po-datepicker class="po-sm-12 po-md-3 po-lg-2"
      name="DFIGVENCTO"
      p-label="Data de Vencimento"
      [(ngModel)]="DDA.DFIGVENCTO"
      [p-iso-format]="formatExtended"
      p-format="dd/mm/yyyy"
      p-required="true"
      p-show-required="true"
    ></po-datepicker>
    <po-decimal class="po-sm-4 po-md-3 po-lg-2 maisti-input-number"
      name="NFIGVALOR"
      p-label="Valor do Título"
      [(ngModel)]="DDA.NFIGVALOR"
      p-decimals-length="2"
      p-max="9999999999999.99"
      p-min="0.01"
      p-required="true"
      p-show-required="true"
      p-icon="po-icon-money"
    ></po-decimal>
    <po-select class="po-sm-12 po-md-3 po-lg-2"
      name="CFIGCONCIL"
      p-label="Conciliado"
      [(ngModel)]="DDA.CFIGCONCIL"
      [p-options]="[
        {value: '1', label: 'Sim'},
        {value: '2', label: 'Não'},
      ]"
      p-required="true"
      p-show-required="true"
    ></po-select>
    <po-datepicker class="po-sm-12 po-md-3 po-lg-2"
      name="DFIGDTCONC"
      p-label="Data da Conciliacao"
      [(ngModel)]="DDA.DFIGDTCONC"
      [p-iso-format]="formatExtended"
      p-format="dd/mm/yyyy"
      p-required="false"
      p-show-required="true"
    ></po-datepicker>
    <po-input class="po-sm-6 po-md-3 po-lg-2"
      name="CFIGUSCONC"
      p-label="Usuario Conciliacao DDA"
      [(ngModel)]="DDA.CFIGUSCONC"
      p-required="false"
      p-show-required="true"
      p-maxlength="25"
      p-disabled="false"
    ></po-input>
    <po-input class="po-sm-6 po-md-3 po-lg-2"
      name="CFIGDDASE2"
      p-label="Título Relacionado SE2"
      [(ngModel)]="DDA.CFIGDDASE2"
      p-required="false"
      p-show-required="true"
      p-maxlength="100"
      p-disabled="false"
    ></po-input>
    <po-input class="po-sm-6 po-md-6 po-lg-4"
      name="CFIGCODBAR"
      p-label="Código de Barras DDA"
      [(ngModel)]="DDA.CFIGCODBAR"
      p-required="true"
      p-show-required="true"
      p-maxlength="44"
      p-disabled="false"
    ></po-input>
  </form>
  <po-modal-footer>
    <po-button class="po-sm-12 po-md-6 po-lg-6"
      p-label="Gravar Dados"
      p-icon="po-icon-ok"
      (p-click)="gravarDDA()"
    ></po-button>
    <po-button class="po-sm-12 po-md-6 po-lg-6"
      p-label="Cancelar"
      p-icon="po-icon-cancel"
      (p-click)="DDAModal.close()"
      p-danger="true"
    ></po-button>
  </po-modal-footer>

</po-modal>
